import { MenuEntry } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const config2: (t: ContextApi['t']) => MenuEntry[] = (t) => [
  {
    label: t('Home'),
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: t('Trade'),
    icon: 'TradeIcon', 
    items: [
      {
        label: t('Exchange'),
        href: '/ethswap',
      },
      {
        label: t('Charts'),
        href: '/charts',
      },
    ],
  },
  {
    label: t('Community'),
    icon: 'CharityIcon',
    items: [
      {
        label: t('Chat'),
        href: '/chat',
      },
      {
        label: t('Referral'),
        href: '/referral',
      },
      {
        label: t('Donation'),
        href: '/donation',
      },
    ],
  },
      {
        label: t('Learn'),
        icon: 'MoreIcon',
        items: [
          {
            label: t('Docs'),
            href: '/partnership',
          },
        ],
        
      },
      
    ]
  

export default config2
